import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class BuyerPedidosService extends BaseService {
    private _domain: string = '/buyer/orders';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public getByQuotationId(quotationId: number): Observable<any> {
        return this.config.executeGet({ url: `${this._domain}/quotation/${quotationId}` });
    }

    public listOrdersHistory(filter: string): Observable<any> {
        const buyerCompanyId = this.userService.userCompanyId();

        return this.config.executeGet({ url: `${this._domain}/${buyerCompanyId}/history?filter=${filter}` });
    }

    public getAllLast30Days(): Observable<any> {
        const buyerCompanyId = this.userService.userCompanyId();

        return this.config.executeGet({ url: `${this._domain}/${buyerCompanyId}/last-30-days` });
    }
}
